import React from 'react';
import Button from '../Button';

const ConfirmationModal = ({ message, onConfirm, onCancel, invertButtons = false }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-3xl shadow-lg max-w-md w-full">
        <div className="mb-4 text-center">{message}</div>
        <div className="flex justify-center space-x-4">
          {invertButtons ? (
            <>
              <Button onClick={onConfirm} variant="transparent-orange">Sì</Button>
              <Button onClick={onCancel} variant="blue">No</Button>
            </>
          ) : (
            <>
              <Button onClick={onCancel} variant="transparent-orange">No</Button>
              <Button onClick={onConfirm} variant="blue">Sì</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
